/* istanbul ignore file */
import { RESET_CONTEST_DATA } from './constants';

export const resetContestData = () => {
  return {
    type: RESET_CONTEST_DATA
  }
}

export function reducer(state, { type }) {
  switch (type) {
    case RESET_CONTEST_DATA:
      return {
        ...state,
        contestEventResults: {},
        contestEventAgents: []
      };
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/features/contests/redux/resetContestData.js